<nz-modal
    [nzTitle]="'Lịch sử sửa đổi' + (orderTypeName ? ' - ' + orderTypeName : '')"
    [nzWidth]="800"
    [(nzVisible)]="visibleOrderTypeLog"
    (nzOnCancel)="closeModalLog()"
    [nzFooter]="modalFooterConfig"
    [nzContent]="modalContentConfig"
  >
    <ng-template #modalContentConfig>
      <dx-data-grid
        #grid
        [dataSource]="datas"
        [showColumnLines]="true"
        [showRowLines]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [allowColumnResizing]="true"
        columnResizingMode="widget"
        [columnMinWidth]="50"
        [columnAutoWidth]="true"
        [height]="500"
      >
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxi-column caption="Thời gian" dataField="datelog" dataType="date" format="HH:mm dd/MM/yyyy" [width]="140" [sortOrder]="'desc'"></dxi-column>
        <dxi-column caption="Người thực hiện" dataField="userName" [width]="130"></dxi-column>
        <dxi-column caption="Thao tác" dataField="actionType" [width]="100"></dxi-column>
        <dxi-column caption="Nội dung thay đổi" dataField="changedData" cellTemplate="cellChangedData"></dxi-column>
        <dxi-column caption="" cellTemplate="cellDetail" [width]="70" [allowFiltering]="false" [allowSorting]="false" cssClass="text-center"></dxi-column>
        <div *dxTemplate="let item of 'cellChangedData'" class="changed-data-cell" [title]="item.data.changedData">
          {{ item.data.changedData }}
        </div>
        <div *dxTemplate="let item of 'cellDetail'">
          <button nz-button nzSize="small" nzType="default" title="Xem chi tiết" (click)="showDetail(item.data)">
            <span class="fa fa-fw fa-eye"></span>
          </button>
        </div>
      </dx-data-grid>
    </ng-template>
    <ng-template #modalFooterConfig>
      <button nz-button nzType="default" (click)="closeModalLog()">
        Đóng
      </button>
    </ng-template>
</nz-modal>

<nz-modal
    nzTitle="Chi tiết thay đổi"
    [nzWidth]="500"
    [(nzVisible)]="isVisibleDetail"
    (nzOnCancel)="closeDetail()"
    [nzFooter]="null"
>
  <ng-container *nzModalContent>
    <div class="detail-row"><b>Thời gian:</b> {{ selectedLog?.dateLog | date: 'HH:mm dd/MM/yyyy' }}</div>
    <div class="detail-row"><b>Người thực hiện:</b> {{ selectedLog?.userName }}</div>
    <div class="detail-row"><b>Thao tác:</b> {{ selectedLog?.actionType }}</div>
    <div class="detail-row"><b>Nội dung thay đổi:</b></div>
    <div class="detail-content">{{ selectedLog?.changedData }}</div>
  </ng-container>
</nz-modal>
